var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUploadFailed = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F71305",
    fillRule: "evenodd",
    d: "M4 12c0-1.846.635-3.542 1.688-4.897l11.209 11.209C15.542 19.366 13.846 20 12 20c-4.411 0-8-3.589-8-8zm16 0c0 1.846-.635 3.542-1.688 4.897L7.103 5.688C8.458 4.634 10.154 4 12 4c4.411 0 8 3.589 8 8zM12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUploadFailed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upload_failed.6d920fc4.svg";
export { ForwardRef as ReactComponent };